import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58d626e1")

_pushScopeId("data-v-58d626e1")
const _hoisted_1 = { class: "df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      name: "minus",
      class: _ctx.isBound(true) ? 'c-grey disabled' : '',
      onClick: _ctx.reduce
    }, null, 8, ["class", "onClick"]),
    _createVNode("div", {
      class: "flex-1 t-center",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputMode = true))
    }, [
      (_ctx.inputMode)
        ? (_openBlock(), _createBlock("input", {
            key: 0,
            value: _ctx.output,
            class: "range_input",
            type: "text",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.correct($event.target.value))),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.correct($event.target.value)))
          }, null, 40, ["value"]))
        : _renderSlot(_ctx.$slots, "default", {
            key: 1,
            value: _ctx.output
          }, () => [
            _createTextVNode(_toDisplayString(_ctx.output), 1)
          ], true)
    ]),
    _createVNode(_component_Icon, {
      name: "plus",
      class: _ctx.isBound() ? 'c-grey disabled' : '',
      onClick: _ctx.increase
    }, null, 8, ["class", "onClick"])
  ]))
})